/* projects/speaker-platform/src/app/organisms/resume-statistics-speaker/resume-statistics-speaker.component.scss */
.resume-statistics-speaker {
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 15px;
  padding: 20px;
  background-color: #fff;
  position: relative;
  min-height: 230px;
}
/*# sourceMappingURL=resume-statistics-speaker.component-6LFYKH3K.css.map */
